import { PageDocument } from '../@types/types.generated'
import { resolver } from './resolver'
import { Lang } from '../../const'

export const routeResolver = (page: PageDocument<Lang>): string => {
	const { uid, type, lang } = page
	return resolver(uid, type, lang)
}
